'use strict';
angular
    .module('dnapp')
    .controller('DN.TypeaheadController', ['DN.InternalSearchService', function (dataService) {
        var ctrl = this;

        // Internal variables

        // Controller variables
        ctrl.searchField = '';
        ctrl.searchResults = [];
        ctrl.state = 0;
        ctrl.didSearch = false;
        ctrl.nodeId = 0;

        // Functions
        ctrl.init = function(id) {
            ctrl.nodeId = id;
        }

        ctrl.searchAction = function (action) {
            switch (action) {
                case 0:
                    ctrl.state = action;
                    ctrl.searchField = '';
                    ctrl.searchResults = [];
                    ctrl.didSearch = false;
                    $('#js-typeahead-backdrop').hide();
                    $('body').removeClass('disable-scrolling');
                    break;
                case 1:
                    ctrl.state = action;
                    break;
            }
        };

        ctrl.enter = function (keycode) {
            if (keycode === 27) {
                ctrl.searchAction(0);
            } else if (keycode === 13 && ctrl.searchField.length > 1) {
                document.location = "/q?id=" + ctrl.nodeId + '&search=' + ctrl.searchField;
            }
        };

        ctrl.typeahead = function () {
            if (ctrl.searchField.length > 1) {
                $('html, body').animate({ scrollTop: 0 }, 'slow');
                $('body').addClass('disable-scrolling');
                dataService.TypeaheadSearch({ q: ctrl.searchField, nodeId: ctrl.nodeId })
                    .$promise.then(function (response) {
                        if (response.Success) {
                            ctrl.searchResults = response.Data;
                            ctrl.didSearch = true;
                            $('#js-typeahead-backdrop').show();
                        } else {
                            $('#js-typeahead-backdrop').hide();
                        }
                    });
            } else {
                ctrl.searchResults = [];
                ctrl.didSearch = false;
                $('#js-typeahead-backdrop').hide();
            }
        };
    }]);